import { render, staticRenderFns } from "./my-prize.vue?vue&type=template&id=4beaa954&scoped=true&"
import script from "./my-prize.vue?vue&type=script&lang=js&"
export * from "./my-prize.vue?vue&type=script&lang=js&"
import style0 from "./my-prize.vue?vue&type=style&index=0&id=4beaa954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beaa954",
  null
  
)

export default component.exports